// ReloadOnErrorBoundary.jsx
import React from "react";
import { Button, Icon, } from 'semantic-ui-react'

const RELOAD_FLAG_KEY = "reloaded_due_to_bundle_error";

class ReloadOnErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, reason: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, reason: error?.message ?? String(error) };
  }

  componentDidCatch(error, errorInfo) {
    // keep the console info
    console.error("Error caught by ReloadOnErrorBoundary:", error, errorInfo);

    const message = error?.message ?? "";
    const shouldReload =
      // change these checks to suit other messages you want to reload for
      message.includes("Unexpected token '<'") ||
      // lazy chunk load failure messages often include "Loading chunk" / "chunk" / "fetch"
      message.includes("Loading chunk") ||
      message.includes("ChunkLoadError");

    if (!shouldReload) return;

    // guard: only reload once per session
    const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG_KEY) === "1";
    if (alreadyReloaded) {
      console.warn("Bundle error occurred but reload already happened in this session.");
      return;
    }

    // set the flag before reloading so we don't loop
    try {
      sessionStorage.setItem(RELOAD_FLAG_KEY, "1");
    } catch (e) {
      // if sessionStorage throws (private mode), fall back to in-memory flag
      // (less reliable across navigations, but better than infinite reload loop)
      // eslint-disable-next-line no-console
      console.warn("sessionStorage not available — reload guard may not persist.", e);
      this._tempReloadGuard = true;
    }

    // optional: short delay so user sees fallback UI and any logs flush
    setTimeout(() => {
      console.warn("Reloading page due to bundle parse/load error...");
      window.location.reload( true );
    }, this.props.reloadDelayMs ?? 300);
  }

  onHandleReloadClick = () => {
  
    // Delete caches...
    if ('caches' in window) {
      caches.keys().then((names) => {
          names.forEach(async (name) => {
              await caches.delete(name)
          })
      });
    }
  
    window.location.reload( true );
  }
  

  render() {
    if (this.state.hasError) {
      // You can customize this fallback UI
      return (
        <div style={{ padding: 20, textAlign: "center" }}>
          {/* <h2>Something went wrong</h2> */}
          <h4>Attempting to recover — reloading the page now.</h4>

           <Button color='teal' onClick={this.onHandleReloadClick}>
              <Icon name='refresh' />RELOAD
            </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ReloadOnErrorBoundary;
